import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import PageLayout from '@/layouts/PageLayout.vue';
import AboutSection from '@/components/sections/AboutSection.vue';
import SkillsSection from '@/components/sections/SkillsSection.vue';
import PortfolioSection from '@/components/sections/PortfolioSection.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const LEGACY_HASHES: Record<string, string> = {
  '#uses': '#conhecimentos',
};

onMounted(() => {
  let { hash } = globalThis.location;
  if (!hash) return;

  hash = LEGACY_HASHES[hash] ?? hash;

  requestAnimationFrame(() => {
    const el = document.querySelector(hash);
    if (!el) return;
    const prefersReduced = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({
      behavior: prefersReduced ? 'auto' : 'smooth',
      block: 'start',
    });
    if (hash !== globalThis.location.hash) {
      globalThis.history.replaceState(null, '', hash);
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageLayout, null, {
    default: _withCtx(() => [
      _createVNode(AboutSection),
      _createVNode(SkillsSection),
      _createVNode(PortfolioSection)
    ]),
    _: 1
  }))
}
}

})